import Timing from './timing';
import { ROUTINE } from 'constants/general';
import { FLAG, PackEditorTabMode } from 'enums';
import { ATTRIB } from 'constants/test';
import { store } from 'store';
import {
  filterOutCustomTiming,
  getRoutineValue
} from 'utils/routine-suggestion.util';
import { isMobilePlatform, SettingsContentMode } from 'utils/settings.util';
import MorningRevamp from './routines/MorningRevamp';
import CustomRoutines from 'components/setting-generator-revamp/tabs-body-steps-revamp/custom-routines';
import HabitPacks from 'components/setting-generator-revamp/tabs-body-steps-revamp/habit-packs';
import FocusModeAllowedAppsAndURLsRevamp from './FocusModeAllowedAppsAndURLsRevamp';
import PackAndFocusModeInfo from 'components/setting-generator-revamp/tabs-body-steps-revamp/habit-packs/PackAndFocusModeInfo';
import StandaloneActivitiesRevamp from './routines/StandaloneActivitiesRevamp';
import BreaksRevamp from './routines/BreaksRevamp';
import EveningRevamp from './routines/EveningRevamp';

export const DEFAULT_STEP_TO_STEP_NUMBER_MAPPING: {
  [key: string]: JSX.Element;
} = {
  '0': <Timing />,
  '1': <MorningRevamp />,
  '2': <BreaksRevamp />,
  '3': <EveningRevamp />,
  '4': <CustomRoutines />,
  '5': <HabitPacks />
};

export const DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_CUSTOM_ROUTINES: {
  [key: string]: JSX.Element;
} = {
  '0': <Timing />,
  '1': <MorningRevamp />,
  '2': <BreaksRevamp />,
  '3': <EveningRevamp />,
  '4': <HabitPacks />
};

export const DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_MICRO_BREAKS: {
  [key: string]: JSX.Element;
} = {
  '0': <Timing />,
  '1': <MorningRevamp />,
  '2': <EveningRevamp />,
  '3': <CustomRoutines />,
  '4': <HabitPacks />
};

export const DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_MICRO_BREAKS_AND_CUSTOM_ROUTINES: {
  [key: string]: JSX.Element;
} = {
  '0': <Timing />,
  '1': <MorningRevamp />,
  '2': <EveningRevamp />,
  '3': <HabitPacks />
};

export const FOCUS_MODE_STEP_TO_STEP_NUMBER_MAPPING: {
  [key: string]: JSX.Element;
} = {
  '0': <FocusModeAllowedAppsAndURLsRevamp />,
  '1': <PackAndFocusModeInfo />
};

export const HABIT_PACK_STEP_TO_STEP_NUMBER_MAPPING: {
  [key: string]: JSX.Element;
} = {
  '0': <MorningRevamp />,
  '1': <BreaksRevamp />,
  '2': <EveningRevamp />,
  '3': <PackAndFocusModeInfo />
};

export const STANDALONE_STEP_TO_STEP_NUMBER_MAPPING: {
  [key: string]: JSX.Element;
} = {
  '0': <StandaloneActivitiesRevamp />,
  '1': <PackAndFocusModeInfo />
};

export const ROUTINE_STEP_TO_STEP_NUMBER_MAPPING: {
  [key: string]: JSX.Element;
} = {
  [ROUTINE.MORNING]: <MorningRevamp />,
  [ROUTINE.BREAKING]: <BreaksRevamp />,
  [ROUTINE.EVENING]: <EveningRevamp />
};

export const getSettingPageTabContent = (
  contentMode: SettingsContentMode,
  index: number,
  customRoutine: string,
  platform: string,
  isUserAdmin: boolean,
  flags: FLAG[]
) => {
  let body, testIds;
  switch (contentMode) {
    case PackEditorTabMode.ROUTINE:
      body = HABIT_PACK_STEP_TO_STEP_NUMBER_MAPPING[index.toString()];
      testIds = ATTRIB.TEST.HEADERS.ROUTINE;
      break;
    case PackEditorTabMode.STANDALONE:
      body = STANDALONE_STEP_TO_STEP_NUMBER_MAPPING[index.toString()];
      testIds = ATTRIB.TEST.HEADERS.STANDALONE;
      break;
    case PackEditorTabMode.FOCUS_MODE:
      body = FOCUS_MODE_STEP_TO_STEP_NUMBER_MAPPING[index.toString()];
      break;
    default: {
      if (customRoutine && Object.values(ROUTINE).includes(customRoutine)) {
        if (customRoutine === ROUTINE.SUGGESTION) {
          const routines = store
            .getState()
            .routineSuggestions.routineSuggestionPayload.routines.slice();
          const shouldSelectBothRoutines = filterOutCustomTiming(
            routines
          ).every((routine) => routine.value);
          const routine = getRoutineValue(routines);
          body = shouldSelectBothRoutines
            ? ROUTINE_STEP_TO_STEP_NUMBER_MAPPING[
                index === 0 ? ROUTINE.MORNING : ROUTINE.EVENING
              ]
            : ROUTINE_STEP_TO_STEP_NUMBER_MAPPING[routine];
        } else {
          body = ROUTINE_STEP_TO_STEP_NUMBER_MAPPING[customRoutine];
        }
      } else if (
        !flags.includes(FLAG.GEEK_MODE) &&
        isMobilePlatform(platform)
      ) {
        body = flags.includes(FLAG.CUSTOM_ROUTINES_DEV_MODE)
          ? DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_MICRO_BREAKS[
              index.toString()
            ]
          : DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_MICRO_BREAKS_AND_CUSTOM_ROUTINES[
              index.toString()
            ];
      } else if (isMobilePlatform(platform)) {
        body = isUserAdmin
          ? DEFAULT_STEP_TO_STEP_NUMBER_MAPPING[index.toString()]
          : DEFAULT_STEP_TO_STEP_NUMBER_MAPPING_WITHOUT_CUSTOM_ROUTINES[
              index.toString()
            ];
      } else {
        body = DEFAULT_STEP_TO_STEP_NUMBER_MAPPING[index.toString()];
      }
      testIds = ATTRIB.TEST.HEADERS.DEFAULT;
    }
  }
  return { body, testIds, platform };
};
